export type SXType = React.CSSProperties | undefined;
/**
 * Force text wrapping and line breaking.
 */
export const forceWrap: SXType = {
  textWrap: "wrap",
  lineBreak: "anywhere"
};
